import { Component, HostListener } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DriverRecordRequestService } from '../../../services/driverrecordrequest.service';
import { GeneralService } from '../../../services/general.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { TranslatorService } from '../../../services/translator.service';
import { IWizard } from '../../../interfaces/iwizard';
import { WizardSteps } from '../../../interfaces/wizard-steps';
import UserIdResponse from 'src/app/interfaces/IDQuiz/LexisNexisWebApi/GetQuizResponse/userIdResponse';
import { Router } from '@angular/router';
import QuestionSet from '../../../interfaces/IDQuiz/LexisNexisWebApi/GetQuizResponse/questionSet';
import Product from 'src/app/interfaces/IDQuiz/LexisNexisWebApi/product';
import VerifyQuizResponse from 'src/app/interfaces/IDQuiz/LexisNexisWebApi/VerifyQuizResponse/verifyQuizResponse';
import Question from 'src/app/interfaces/IDQuiz/LexisNexisWebApi/GetQuizResponse/question';

@Component({
    selector: 'app-id-quiz',
    templateUrl: './id-quiz.component.html',
    styleUrls: ['./id-quiz.component.scss'],
    standalone: false
})
export class IdQuizComponent {

     public wizard!: IWizard;

     constructor (public service: DriverRecordRequestService,
          public generalService: GeneralService,
          public authenticationService: AuthenticationService,
          public _router: Router,
          public translatorService: TranslatorService) {
          this.wizard = this.service.getWizard();
     }

     idQuiz: QuestionSet = {
          questions: [],
          questionSetId: 0,
          conversationId: ''
     };
     skipQuiz: boolean = false;
     loadingQuiz: boolean = true;
     isSaving: boolean = false;
     userPassedQuiz: boolean = true;
     hasErrors: boolean = true;

     async ngOnInit(): Promise<void> {
          setTimeout(() => this.scrollToTop(), 500);
          this.handleBeforeUnload = this.unloadMessage;

          this.loadingQuiz = true;

          if (this.service.isDriverRequestInitialized === false && this.service.loadFromLocal() === false) {
               this._router.navigateByUrl('/driver/1');
          }

          const language = this.translatorService.getActiveLanguage().toUpperCase();
          const userIdQuiz = await this.service.getDriverIdQuiz(language);
          if (userIdQuiz) {
               await this.loadQuiz(userIdQuiz);
          } else {
               // Error occurred getting quiz. 
               // Will land here if user refreshes the page on idVerify
               this.navigateToLexisNexisFail();
          }

          try {
               window.document.getElementById('selectLanguageBtn')!.style.display = 'none';
          } catch (e) {
               console.error(e)
          }
     }

     async loadQuiz(userIdQuiz: UserIdResponse | any) {
          this.skipQuiz = this.service.driverRequest.billingAddressSame === false;
          let identityFound = false;

          if (!userIdQuiz || !userIdQuiz.status || userIdQuiz.status.transactionStatus === 'error' || userIdQuiz.status.transactionStatus === 'failed') {
               // Either call to L/N call failed (error) or info provided didn't meet minimum matching information for L/N to produce a quiz (failed).
               // Failed quizes are logged from psp-next web-api

               this.navigateToLexisNexisFail();
               return;
          }

          if (userIdQuiz.status && userIdQuiz.products && userIdQuiz.status.transactionStatus === 'pending') {
               userIdQuiz.products.forEach((product: Product | any) => {
                    if (product && product.productType === 'Discovery') {
                         identityFound = product.productStatus === 'pass';
                    }
                    if (product && product.productType === 'IIDQA' && product.questionSet) {
                         this.idQuiz = product.questionSet;
                    }
               });
               this.idQuiz.conversationId = userIdQuiz.status.conversationId;
          }

          if (identityFound === false) {
               this.navigateToLexisNexisFail();
          } else if (identityFound && this.skipQuiz === false) {
               this.handleBeforeUnload = this.noUnloadMessage;
               const redirectUrl = this.service.initiatePayment();
               redirectUrl.then((v: any) => this.navigateToPayment(v));
          } else {
               this.loadingQuiz = false;
          }
     }

     gradeQuiz() {
          this.loadingQuiz = true;
          const language = this.translatorService.getActiveLanguage().toUpperCase();
          const gradedIdQuizPromise = this.service.gradeDriverIdQuiz(this.idQuiz, language);
          gradedIdQuizPromise.then((v: any) => this.moveNext(v));
     }

     moveNext(gradedQuiz: VerifyQuizResponse | any) {
          this.handleBeforeUnload = this.noUnloadMessage;
          if (!gradedQuiz || !gradedQuiz.status || !gradedQuiz.status.transactionStatus || !gradedQuiz.products) {
               this.generalService.pageLogging('/driver/9', null, '', 'There was a problem with the Lexis Nexis quiz for driver with email ' + this.service.driverRequest.emailAddress, '');
               this._router.navigateByUrl('/applicationException');
          }

          const lnTransactionSuccess: boolean = gradedQuiz &&
               gradedQuiz.status.transactionStatus &&
               gradedQuiz.status.transactionStatus === 'passed' &&
               gradedQuiz.products &&
               gradedQuiz.products.length > 1;
          this.userPassedQuiz = false;
          if (lnTransactionSuccess) {
               gradedQuiz.products.forEach((product: Product) => {
                    if (product &&
                         product.productType &&
                         product.productType === 'IIDQA' &&
                         product.productStatus &&
                         product.productStatus === 'pass') {
                         this.userPassedQuiz = true;
                    }
               });
          }
          const passedText = lnTransactionSuccess ? 'passed' : 'failed'
          this.generalService.pageLogging('/driver/9', null, '', '', 'Lexis Nexis quiz ' + passedText + '. Driver email: ' + this.service.driverRequest.emailAddress);
          
          if (this.userPassedQuiz && this.service.justSubscribe) {
               const monitoringPromise = this.service.enrollInMonitoring();
               this.generalService.pageLogging('/driver/9', null, '', '', 'Enrolled in monitoring with Lexis Nexis quiz for email ' + this.service.driverRequest.emailAddress);
               monitoringPromise.then((result: any) => this.navigateToNext(result));
          } else if (this.userPassedQuiz) {
               const redirectUrl = this.service.initiatePayment();
               redirectUrl.then((result: any) => this.navigateToPayment(result));
          } else {
               this.navigateToLexisNexisFail();
          }
     }

     navigateToNext(redirectUrl: string | any) {
          if (redirectUrl.startsWith('/')) {
               this._router.navigateByUrl(redirectUrl);
          } else {
               window.location = redirectUrl;
          }
     }

     navigateToPayment(redirectUrl: string | any) {
          this.handleBeforeUnload = this.noUnloadMessage;
          this.translatorService.backupLanguage();
          if (redirectUrl) {
               redirectUrl = redirectUrl as string;
               const language = this.translatorService.getActiveLanguage().toUpperCase();
               if (redirectUrl.startsWith('/')) {
                    this._router.navigateByUrl(redirectUrl);
               } else if (redirectUrl.toLowerCase().includes('checkout') === true) {
                    if (language.toLowerCase() !== 'en') {
                         redirectUrl = redirectUrl + '&lang=' + language.toLowerCase();
                    }
                    this.generalService.pageLogging('/driver/9', null, '', '',
                         'Redirecting driver to payment from ID Verify, email: ' + this.service.driverRequest.emailAddress);
                    window.location = redirectUrl;
               } else if (redirectUrl.includes('orderFail')) {
                    this.generalService.pageLogging('/driver/9', null, '',
                         'Order failed in driver wizard from ID Verify, email: ' + this.service.driverRequest.emailAddress, '');
                    this._router.navigateByUrl('/driver/11');
               } else if (redirectUrl.includes('dupLic')) {
                    this.generalService.pageLogging('/driver/9', null, '',
                         'Order failed in driver wizard from ID Verify due to duplicate license found. Email: ' + this.service.driverRequest.emailAddress, '');
                    window.location = redirectUrl;
               } else {
                    this.generalService.pageLogging('/driver/9', null, '',
                         'Navigating to customer support. Order results inconclusive in driver wizard from ID Verify, email: ' + this.service.driverRequest.emailAddress, '');
                    this._router.navigateByUrl('/customerSupportInfo');
               }
          } else {
               this.generalService.pageLogging('/driver/9', null, '',
                    'Navigating to customer support. Redirect url for payment was null. Driver email: ' + this.service.driverRequest.emailAddress, '');
               this._router.navigateByUrl('/customerSupportInfo');
          }
     }

     navigateToLexisNexisFail() {
          this.generalService.pageLogging('/driver/9', null, '', '',
               'Driver ID Verify failed for driver with email: ' + this.service.driverRequest.emailAddress);
          this.handleBeforeUnload = this.noUnloadMessage;
          this._router.navigateByUrl('/driver/12');
     }

     selectionChanged(questionId: number, choiceId: number | any) {
          let missingSelection = false;
          if (this.idQuiz.questions.length > 0) {
               for (let questionIndex = 0; questionIndex < this.idQuiz.questions.length; questionIndex++) {
                    if (this.idQuiz.questions[questionIndex].questionId === questionId) {
                         this.idQuiz.questions[questionIndex].userChoiceId = choiceId;
                    }
                    if (!this.idQuiz.questions[questionIndex].userChoiceId) {
                         missingSelection = true;
                    }
               }
          }
          this.hasErrors = missingSelection;
     }

     ngOnDestroy() {
          try {
               var e = window.document.getElementById('selectLanguageBtn');
               if (e) {
                    e.style.display = 'block';
               }
          } catch (ex) {
               console.error('Language drop down either did not have hidden attribute or error occurred removing it. ');
               console.error(ex)
          }
     }

     scrollToTop() {
          window.scrollTo(0, 0);
     }

     @HostListener('window:beforeunload', ['$event'])
     handleBeforeUnload(event: any): void { };

     unloadMessage($event: { returnValue: string; }) {
          return $event.returnValue = 'Your changes will not be saved';
     }
     noUnloadMessage(): void { }
}

